export const fetchUsersByType = async ({
    BeURL,
    type,
    page,
    limit,
}) => {
    console.log("fetching users", BeURL , type , page , limit)
    try {
        const res = await fetch(
            `${BeURL}/users?type=${type}&page=${page}&limit=${limit}`,
            {
                method : 'GET',
                credentials: "include",
            }
        );

        const data = await res.json();

        return data;

    } catch (err) {
        console.log(err);
        return null;
    }
};
